export { default } from './ReferralPromotionDetails.container';
